import Papa from "papaparse";
import { useEffect, useState, useMemo } from "react";
import axios from 'axios';
import { KTIcon } from "../../../_metronic/helpers";
import fetchAPI from "../../../common/fetchAPI";
import { CSVDownload, CSVLink } from "react-csv";
import { AccountImportExport } from "../importExport/AccountImportExport";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Select, { StylesConfig } from 'react-select';
import { ShowSwal } from "../../../common/SweetAlert";
import { getDataSourceSchemaAsync, ImportCSVAsync, checkImportValidationForDuplicateDataAsync, setIsLoading, setisImportExport } from "./importExportSlice";
import { ShowToast } from "../../../common/Toastr";
import { Console } from "console";
import { useNavigate } from "react-router-dom";
import Loader from "../../../common/Loader";
import * as XLSX from "xlsx";
import { truncate } from "fs";
import { useTranslation } from "react-i18next";
import { getValueFromResource } from "../../../common/timeLiveFunction";


let isHandleSelected = false;
export const AccountImportExportMapping = (props: any) => {
    const { TableName, csvData, dbTable, Table, IsUpdate, headerResponse } = props;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { ImportExportList, fileName, selectedRecord, DataSourceSchema, isLoading, isImportExport } = useAppSelector((state) => state.importExport);
    const [tempSelection, setTempSelection] = useState<{ [key: number]: string }>({});
    const [DatabaseColumn, SetAllDatabaseColumn] = useState<any | ''>([]);
    const [checkboxState, setCheckboxState] = useState(
        DatabaseColumn.map((item: any) => !!item.Required)  // Initialize based on Required field
    );

    const [selectedColumn, setSelectedColumn] = useState('');
    const [validationFailed, setValidationFailed] = useState(false);
    const navigate = useNavigate();
    // const [updatedCsvData, setUpdatedCsvData] = useState([csvData]);
    const [updatedCsvData, setUpdatedCsvData] = useState<any | ''>([]);

    // const [trandferData, setTrandferData] = useState<any | ''>([]);
    ///
    const [dropdownData, setDropdownData] = useState<any | ''>([]);

    
    useMemo(() => {
        if (csvData.length > 0) {
            const dropdownOptions = headerResponse.map((key: any) => ({
                value: key,
                label: key
            }));
            dropdownOptions.unshift({ value: '0', label: 'Select' });
            setDropdownData(dropdownOptions);
            setUpdatedCsvData(csvData);
        }
    }, []);

    // useEffect(() => {
    //     setUpdatedCsvData(csvData);
    //     setTrandferData(csvData);
    //     // {value: 'PartyNick', label: 'PartyNick'}
    //     // {value: 0, label: 'Select'}
    // }, []);



    // const handleCheckboxChange = (index: number) => {
    //     setCheckboxState((prevState:any) => {
    //         const newState = [...prevState];
    //         newState[index] = !newState[index];
    //         newState.forEach((_, idx) => {
    //             if (idx !== index) {
    //                 newState[idx] = false;
    //             }
    //         });
    //         return newState;
    //     });
    // };

    const handleCheckboxChange = (index: number) => {
        setCheckboxState((prevState: any) => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const getAllColumnsOfDBForMapping = async () => {
        const response = await fetchAPI('api/v2/ImportExport/GetAllColumnsOfDBForMapping/' + TableName + '/' + IsUpdate, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        SetAllDatabaseColumn(json.Data);
    }

    useEffect(() => {
        getAllColumnsOfDBForMapping();
    }, [selectedRecord])


    const handleOnBackClickEvent = () => {
        dispatch(setisImportExport(true));
    }

    const padTime = (time: string) => {
        const timeParts = time.split(':');
        if (timeParts[0].length === 1) {
            timeParts[0] = '0' + timeParts[0];
        }
        return timeParts.join(':');
    };

    const CSVcolumnNames = csvData.length > 0 ? Object.keys(csvData[0]) : [];
    const isValidDataType = (columnName: any, value: any, dataType: any, rowIndex: number) => {

        if (dataType === 'bit' && value === null || value === "" || value === 0) {
            value = "0";
        } else if (dataType === 'bit' && value === 1) {
            value = "1";
        }

        switch (dataType) {
            case 'int':
                return Number.isInteger(Number(value));
            case 'nvarchar':
                // return typeof value === 'string' || !isNaN(Number(value));
                if (typeof value === 'number') {
                    csvData[rowIndex][columnName] = value.toString();
                }
                return value;
            case 'bit':
                return value === '0' || value === '1' || value === true || value === false || value === 'Yes' || value === 'No';
            // case 'datetime':
            //     if (/^\d{1}:\d{2}:\d{2}$/.test(value)) {
            //         value = padTime(value);
            //     }
            //     return !isNaN(Date.parse(value)) || /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(value);
          case 'datetime':
                if (!value) return true;
                if (/^\d{1}:\d{2}:\d{2}$/.test(value)) {
                    value = padTime(value);
                }
                if (/^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(value)) {
                    return true;
                }
                const slashDatePattern = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/;
                if (slashDatePattern.test(value)) {
                    const parts = value.split(/[\/\-]/);
                    const day = parts[0].padStart(2, '0');
                    const month = parts[1].padStart(2, '0');
                    const year = parts[2];
                    
                    if (Number(year) >= 1900 && Number(month) >= 1 && Number(month) <= 12 && Number(day) >= 1 && Number(day) <= 31) {
                        return true;
                    }
                }
                const isoDatePattern = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/;
                if (isoDatePattern.test(value)) {
                    return !isNaN(Date.parse(value));
                }

                return !isNaN(Date.parse(value));
          
            case 'time':
                return /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(value);
            case 'uniqueidentifier':
                if (value !== "" && value && undefined && value !== null && value.trim().length === 36) {
                    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(value);
                }
                else {
                    return value;
                }
            default:
                return true;
        }
    };

    const CheckValidationsLength = (tableSchema: any) => {
        for (let rowIndex = 0; rowIndex <= csvData.length - 1; rowIndex++) {
            const excelRow = csvData[rowIndex];

            for (const columnInfoRow of tableSchema) {
                const columnName = columnInfoRow["Column Name"];
                const maxLength = columnInfoRow["Max Length"] || 0;
                const cellValue = excelRow[columnName] || '';
                if (maxLength > 0 && cellValue.length > maxLength) {
                    if (cellValue.length > maxLength) {
                        ShowSwal('ATTENTION PLEASE', `The value violates the MaxLength limit of this cell. Column Name: "${columnName}", Row No: "${rowIndex + 1}".  `, "warning");
                    }
                    setValidationFailed(true);
                    return;
                }
            }
        }
    }
    // const CheckValidationsEmptyColumns = () => {
    //     for (let rowIdx = 0; rowIdx < csvData.length; rowIdx++) {

    //         const CSVColumnRow = csvData[rowIdx];
    //         for (const DBcolumnInfoRow of DatabaseColumn) {
    //             const DbColumn = DBcolumnInfoRow["DBColumnName"];
    //             const DbType = DBcolumnInfoRow["Datatype"];
    //             const Required = DBcolumnInfoRow["Required"];
    //             const cellValue = CSVColumnRow[DbColumn] || '';

    //             console.log('AK-DbColumn :',DbColumn,Required.length, 'AK-cellValue :', cellValue)
    //             if (Required.length > 0 && cellValue === '' ) {

    //                 ShowSwal('ATTENTION PLEASE', `Required Field "${DbColumn}" is empty at Row No: "${rowIdx + 1}".`, "warning");
    //                 setValidationFailed(true);
    //                 return false;
    //             }
    //         }
    //     }
    //     return true;
    // }

    const CheckValidationsEmptyColumns = () => {
        for (let rowIdx = 0; rowIdx < csvData.length; rowIdx++) {
            const CSVColumnRow = csvData[rowIdx];
            for (const DBcolumnInfoRow of DatabaseColumn) {
                const DbColumn = DBcolumnInfoRow["DBColumnName"];
                const DbType = DBcolumnInfoRow["Datatype"];
                const Required = DBcolumnInfoRow["Required"];
                // const cellValue = CSVColumnRow[DbColumn] || '';
                const cellValue = CSVColumnRow[DbColumn];
                if (DbColumn === 'ProjectDescription') {
                    continue;
                }
                if (DbColumn === 'PartyNick') {
                    continue;
                }
                if(!IsUpdate && DbColumn === "AccountProjectId"){
                    continue;
                }
                if(!IsUpdate && DbColumn === "AccountProjectTaskId"){
                    continue;
                }
                if (Required.length > 0) {
                    if (cellValue === null || cellValue === "" || cellValue.length < 1) {
                        ShowSwal('ATTENTION PLEASE', `Required Field "${DbColumn}" is empty at Row No: "${rowIdx + 1}".`, "warning");
                        setValidationFailed(true);
                        return false;
                    }
                }
            }
        }
        return true;
    }

    const CheckValidationDataTypes = (tableSchema: any) => {
        for (let rowIndex = 0; rowIndex < csvData.length; rowIndex++) {
            const excelRow = csvData[rowIndex];
            for (const columnInfoRow of tableSchema) {
                const columnName = columnInfoRow["Column Name"];
                const dataType = columnInfoRow["Data Type"];
                const maxLength = columnInfoRow["Max Length"] || 0;
                const cellValue = excelRow[columnName] || '';
                if (!excelRow.hasOwnProperty(columnName)) {
                    continue;
                }
                if (!isValidDataType(columnName, cellValue, dataType, rowIndex)) {
                    ShowSwal('ATTENTION PLEASE', `Invalid data type for column ${columnName}, Row No: ${rowIndex + 1}. Expected data type: ${dataType}.`, "warning");
                    setValidationFailed(true);
                    return false;
                }
                if (maxLength > 0 && cellValue.length > maxLength) {
                    if (cellValue.length > maxLength) {
                        ShowSwal('ATTENTION PLEASE', `The value violates the MaxLength limit of this cell. Column Name: "${columnName}", Row No: "${rowIndex + 1}".  `, "warning");
                        setValidationFailed(true);
                        return false;
                    }
                }
            }
        }
        return true;
    }

    const handleExport = (data: any, fileName: any) => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };


    const ImportCSVFile = (filteredCSVData: any) => {

        dispatch(setIsLoading(true))
        // const dataToPass = IsUpdate ? filteredCSVData : csvData;
        const dataToPass = IsUpdate ? filteredCSVData : updatedCsvData

        dispatch(ImportCSVAsync({ data: dataToPass, dbTable: dbTable, Table: Table, IsUpdate: IsUpdate }))
            .unwrap()
            .then((originalPromiseResult: any) => {
                if (originalPromiseResult.StatusCode === "400") {
                    ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                    dispatch(setIsLoading(false));
                    dispatch(setisImportExport(false));
                } else if (originalPromiseResult.StatusCode === "500") {
                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    dispatch(setIsLoading(false));
                    dispatch(setisImportExport(false));
                } else {
                    if (originalPromiseResult.Data !== null) {
                        handleExport(originalPromiseResult.Data, 'Wrong data');
                    } else {
                        ShowToast('CSV Import Successfully', 'Success', "success", "toast-top-right");
                        navigate('/importexport');
                        dispatch(setIsLoading(false));
                        dispatch(setisImportExport(true));
                    }
                }

            })
    }

    const checkImportValidationForDuplicateData = (filteredCSVData: any) => {
        if (!IsUpdate) {
            dispatch(checkImportValidationForDuplicateDataAsync({ data: updatedCsvData, TableName: TableName }))
                .unwrap()
                .then((originalPromiseResult: any) => {
                    if (originalPromiseResult.ResponseMessage !== null) {
                        ShowSwal('ATTENTION PLEASE', originalPromiseResult.ResponseMessage, "warning");
                        setValidationFailed(true);
                        return false;
                    }
                    else {
                        ImportCSVFile(filteredCSVData);
                    }
                })
        }
        else {
            ImportCSVFile(filteredCSVData);
        }
        return true;
    }

 const convertToSQLDate = (value: any) => {
    if (!value) return value;
    if (/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/.test(value)) {
        return value;
    }

    let parsedDate: Date;
    if (typeof value === 'number') {
        parsedDate = new Date(Math.round((value - (25567 + 2)) * 86400 * 1000));
    } else {
        parsedDate = new Date(value);
    }

    if (!isNaN(parsedDate.getTime())) {
        const year = parsedDate.getFullYear();
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
        const day = String(parsedDate.getDate()).padStart(2, '0');
        const hours = String(parsedDate.getHours()).padStart(2, '0');
        const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
        const seconds = String(parsedDate.getSeconds()).padStart(2, '0');

        if (hours !== '00' || minutes !== '00' || seconds !== '00' || value.toString().includes(':')) {
            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        }
        return `${year}-${month}-${day}`;
    }

    const match = value.toString().match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (match) {
        const day = match[1].padStart(2, '0');
        const month = match[2].padStart(2, '0');
        const year = match[3];
        return `${year}-${month}-${day}`;
    }

    return value;
};

const handleOnbtnImportClickEvent = () => {  
    const processedCsvData = updatedCsvData.map((row: any) => {
        const newRow: any = { ...row };
        DatabaseColumn.forEach((column: any) => {
            let cellValue = newRow[column.DBColumnName];
            if (column.Datatype === 'datetime' || /^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{4}$/.test(cellValue) || (cellValue && typeof cellValue === 'string' && cellValue.includes('/'))) {
                newRow[column.DBColumnName] = convertToSQLDate(cellValue);
            }
        });
        return newRow;
    });

    const filteredCSVData = processedCsvData.map((row: any) => {
        const filteredRow: any = {};
        DatabaseColumn.forEach((column: any, index: number) => {
            let cellValue = row[column.DBColumnName];

            if (IsUpdate) {                   
                if (!!column.Required || checkboxState[index]) {
                    filteredRow[column.DBColumnName] = cellValue;
                }
            } else {                    
                filteredRow[column.DBColumnName] = cellValue;
            }
        });
        return filteredRow;
    });

    setUpdatedCsvData(processedCsvData);

        dispatch(getDataSourceSchemaAsync(dbTable))
            .unwrap()
            .then((originalPromiseResult) => {
                const tableSchema = originalPromiseResult.Data;              
                let NotPresentColumns;
                if (isHandleSelected) {
                    NotPresentColumns = DatabaseColumn.find((obj: any) => !processedCsvData[0].hasOwnProperty(obj.DBColumnName) && (obj.Required === 'Required'));                   
                } else {
                    NotPresentColumns = DatabaseColumn.find((obj: any) => !CSVcolumnNames.includes(obj.DBColumnName) && (obj.Required === 'Required'));
                }
                if (NotPresentColumns) {
                    const requiredCoulmn = NotPresentColumns.DBColumnName;
                    ShowSwal('ATTENTION PLEASE', `Field  "${requiredCoulmn}" is required.`, "warning");
                    ShowToast('error', `Field  "${requiredCoulmn}" is required.`, "error", "toast-top-right");
                    setValidationFailed(true);
                    return NotPresentColumns;
                }
                else if (!NotPresentColumns) {
                    setUpdatedCsvData(processedCsvData);
                    if (!CheckValidationsEmptyColumns()) {
                        setValidationFailed(true);
                        return false;
                    }
                    if (!CheckValidationDataTypes(tableSchema)) {
                        setValidationFailed(true);
                        return false;
                    }
                    if (!checkImportValidationForDuplicateData(filteredCSVData)) {
                        setValidationFailed(true);
                        return false;
                    }
                }
            })
            .catch((rejectedValueOrSerializedError) => {
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            });
    };

    // const handleColumnChange = (selectedOption: any, index: any) => {
    //     setSelectedColumn((prevSelectedColumns: any) => ({
    //         ...prevSelectedColumns,
    //         DBColumnName: selectedOption ? selectedOption.value : 0,
    //     }));
    // };

    const handleColumnChange = (dbColumn: string, selectedOption: any, index: number) => {

        isHandleSelected = true;
        const newValue = selectedOption ? selectedOption.value : '';
        const newLabel = selectedOption ? selectedOption.label : '';       
        const previousValue = tempSelection && tempSelection[index] ? tempSelection[index] : ''; 
        if ((previousValue === "" || previousValue === newValue) && newValue === newLabel && newValue === dbColumn) {
            return;
        }

        setTempSelection((prev) => ({
            ...prev,
            [index]: newValue,
        }));

        let tempobject = updatedCsvData.map((item:any) => ({ ...item }));


        tempobject.map((item: any, idx: any) => {
            const originalItem = csvData[idx];
            if (item.hasOwnProperty(dbColumn) && newLabel === 'Select') {
                delete item[dbColumn];
            }
            else if (newLabel !== 'Select') {
                if (originalItem && originalItem.hasOwnProperty(newLabel)) {
                    item[dbColumn] = originalItem[newLabel] ?? "";                    
                }
            }
             return item;
        });       
        setUpdatedCsvData(tempobject);
    };
    const handleIsEnableChange = (e: any, dtCSV: any) => {
        const { checked } = e.target;

    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title">
                        {/* CSV/QUICKBOOKS(IIF) IMPORT EXPORT */}
                        {getValueFromResource('CSV/QUICKBOOKS(IIF) IMPORT EXPORT ', dispatch, t)}

                    </h3>
                    <div className="card-toolbar">
                        <a id="btnImport"
                            className="btn btn-primary btn-sm"
                            style={{ marginRight: '2px' }}
                            onClick={handleOnbtnImportClickEvent}
                        >
                            <KTIcon iconName='arrow-up' className='fs-3' />
                            {/* Import Data */}
                            {getValueFromResource('Import Data', dispatch, t)}
                        </a>
                        <a id="btnBack"
                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm fs-7"
                            onClick={handleOnBackClickEvent}
                        >
                            <KTIcon iconName='arrow-left' className='fs-3' />
                            {/* Back */}
                            {getValueFromResource('Back', dispatch, t)}

                        </a>
                    </div>
                </div>

                <div className='card-body'>
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                {IsUpdate &&
                                    <th style={{ width: '10%' }} className='min-w-100% text-uppercase'>
                                        {/* {'Include In Update'} */}
                                        {getValueFromResource('Include In Update', dispatch, t)}

                                    </th>
                                }
                                <th style={{ width: '30%' }} className='min-w-100% text-uppercase'>
                                    {/* {'TimeLive Column'} */}
                                    {getValueFromResource('TimeLive Column', dispatch, t)}
                                </th>
                                <th style={{ width: '40%' }} className='min-w-100% text-uppercase'>
                                    {/* {'File Column Name'} */}
                                    {getValueFromResource('File Column Name', dispatch, t)}

                                </th>
                                <th style={{ width: '20%' }} className='min-w-100% text-uppercase'>
                                    {/* {'Required'} */}
                                    {getValueFromResource('Required', dispatch, t)}

                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {DatabaseColumn.map((item: any, index: any) => (
                                <tr key={index}>
                                    {IsUpdate &&
                                        <td className='text-center'>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox  justify-content-center'>
                                                <input
                                                    type="checkbox" className="form-check-input widget-9-check"
                                                    id={`Enabled-${index}`}
                                                    checked={!!item.Required || checkboxState[index]}  // Check if Required or manually checked
                                                    disabled={!!item.Required}  // Disable if Required is true
                                                    onChange={() => handleCheckboxChange(index)}
                                                />
                                            </div>
                                        </td>}
                                    <td>{item.DBColumnName}</td>
                                    <td>
                                        {/* <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable={true}
                                            options={options}
                                            onChange={(selectedOption) => handleColumnChange(selectedOption, index)}
                                            value={options.find((option) => option.value === item.DBColumnName)}
                                            //value={options.find((option) => option.value === DatabaseColumn.map((obj : any)=> obj.DBColumnName))}
                                            // value={options.find((option) => DatabaseColumn.some((obj: any) => obj.DBColumnName === option.value))}
                                            styles={colourStyles}
                                        /> */}
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable={true}
                                            // options={options}
                                            options={dropdownData}
                                            value={dropdownData.find((option:any) =>
                                                option.value === (
                                                    tempSelection[index] !== undefined
                                                        ? tempSelection[index]
                                                        : item.DBColumnName || 0
                                                )
                                            )}
                                            //value={dropdownData.find((item: any) => DatabaseColumn.some((obj: any) => obj.DBColumnName === item.value))}
                                            onChange={(selectedOption) => handleColumnChange(item.DBColumnName, selectedOption, index)}
                                            styles={colourStyles}
                                        />
                                    </td>
                                    <td>{item.Required.toString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default AccountImportExportMapping;